import { OffersContainer } from '../OffersContainer';
import { List } from '../../dataProvider';

type SingleEntryOfferProps = {
  offers: List[];
  userEntryCounts?: Record<string, number>;
  onShowEntries?: (list: List) => void;
};

export const SingleEntryOffer = ({
  offers,
  userEntryCounts,
  onShowEntries,
}: SingleEntryOfferProps) => {
  return (
    <OffersContainer
      offers={offers}
      userEntryCounts={userEntryCounts}
      onShowEntries={onShowEntries}
    />
  );
};
